import React, { useState } from "react";
import { Button, Divider, Form, Input, message, Typography } from "antd";
import inputStyles from "../../../styles/Custom/Input.module.css";
import btnStyles from "../../../styles/Custom/Button.module.css";
import textStyles from "../../../styles/Custom/Typography.module.css";
import { mobileLoginApi, userMetaDataApi } from "../../../services/auth.services";
import { setCookie } from "../../../helpers/localStorage";
import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
} from "../../../constants/defaultKeys";

import { useNavigate } from "react-router-dom";
import ChooseOrgModal from "./ChooseOrgModal";
import TermsAndConditionsModal from "./TermsAndConditionsModal";
import { useLoginUserDetails } from "../../../helpers/auth/useLoginUserDetails";

function MobilePassword({ orgID }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {
    handleUserDetailsResponse,
    openOrgModal,
    closeOrgModal,
    openTermsModal,
    handleTermsAccepted,
    acceptingTerms,
  } = useLoginUserDetails(orgID);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const resp = await mobileLoginApi(values);
      if (resp) {
        setCookie(
          ACCESS_TOKEN,
          resp?.data?.access,
          `.${process.env.REACT_APP_PUBLIC_DOMAIN}`,
          "/"
        );
        setCookie(
          REFRESH_TOKEN,
          resp?.data?.refresh,
          `.${process.env.REACT_APP_PUBLIC_DOMAIN}`,
          "/"
        );
        const userResp = await userMetaDataApi();
        handleUserDetailsResponse(userResp?.data);
      }
    } catch (error) {
      console.log(error);
      message.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ChooseOrgModal
        openModal={openOrgModal}
        closable={true}
        onCancel={closeOrgModal}
      />
      <TermsAndConditionsModal
        open={openTermsModal}
        onAccept={handleTermsAccepted}
        acceptLoading={acceptingTerms}
      />
      <Typography
        className="text-center loginIntro"
        style={{ paddingTop: "12px", paddingBottom: "32px" }}
      >
        <br />
        <Typography
          className={`text-center ${textStyles.h5}`}
          // style={{ marginTop: "24px" }}
        >
          Login to your account.
        </Typography>
        <br />
        Please enter your mobile number and password
        <br />
      </Typography>{" "}
      <Form
        autoComplete="off"
        onFinish={onFinish}
        layout="vertical"
        // requiredMark={false}
        style={{ width: "100%" }}
      >
        <Form.Item
          label="Mobile Number"
          name="mobile"
          rules={[
            { required: true, message: "Please enter mobile number" },
            {
              pattern: /^[0-9]{10}$/,
              message: "Please enter a valid 10-digit phone number",
            },
          ]}
        >
          <Input
            maxLength="10"
            placeholder="Mobile Number"
            addonBefore={"+91"}
            className={inputStyles.mdAddonInput}
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[
            { required: true, message: "Please input your password!" },
            {
              max: 500,
              message: "Password cannot exceed 500 characters",
            },
          ]}
        >
          <Input.Password
            placeholder="Enter your password"
            className={inputStyles.mdInput}
            style={{ width: "100%", gap: "0px" }}
          />
        </Form.Item>
        <br />
        <Form.Item style={{ width: "100%", margin: "auto" }}>
          <Button
            loading={loading}
            style={{ width: "100%" }}
            type="primary"
            htmlType="submit"
            className={btnStyles.mdBtn}
          >
            Login
          </Button>
        </Form.Item>
        <Divider>Or</Divider>
        <Typography className="text-center" style={{ paddingTop: "12px" }}>
          Login with{" "}
          <span
            style={{
              color: "#7F56D9",
              cursor: "pointer",
            }}
            onClick={() => navigate("/login?type=email")}
          >
            Email
          </span>{" "}
          /{" "}
          <span
            style={{
              color: "#7F56D9",
              cursor: "pointer",
            }}
            onClick={() => navigate("/login?type=mobile")}
          >
            Mobile OTP
          </span>
        </Typography>
      </Form>
    </>
  );
}

export default MobilePassword;
